
import "./input-v1"
import { CF2Component } from 'javascript/lander/runtime'

export default class CheckoutLoginV1 extends CF2Component {

constructor(el, runtimeSel) {
super(el, runtimeSel)
}

mount() {
    const in1 = this.element.querySelector("input");
    const resendCode = this.element.querySelector(".elLinkResendCode");
    const continueAsGuest = this.element.querySelector(
      ".elLinkContinueAsGuest"
    );
    const ins = [
      ...this.element.querySelectorAll(".elCheckoutLoginInputContent input"),
    ];
    const maxInput = ins.length;

    this.checkoutLoginValid = this.element.querySelector(
      '[data-input-status-type="valid"]'
    );
    this.checkoutLoginError = this.element.querySelector(
      '[data-input-status-type="error"]'
    );

    function focus(input) {
      const end = input.value.length;
      input.type = "text";
      input.setSelectionRange(end, end);
      input.type = "number";
      input.focus();
    }

    resendCode?.addEventListener("click", function () {
      const event = new CustomEvent("CheckoutLinkResendCode");
      document.dispatchEvent(event);
    });
    continueAsGuest?.addEventListener("click", function () {
      const event = new CustomEvent("CheckoutContinueAsGuest");
      document.dispatchEvent(event);
    });

    ins.forEach(function (input, index) {
      input.addEventListener("keyup", function (e) {
        if (
          e.keyCode === 16 ||
          e.keyCode == 9 ||
          e.keyCode == 224 ||
          e.keyCode == 18 ||
          e.keyCode == 17
        ) {
          return;
        }
        let sibling;
        const index = ins.findIndex((i) => i == input);
        const previousIndex = index - 1;
        const nextIndex = index + 1;
        if ((e.keyCode === 8 || e.keyCode === 37) && previousIndex >= 0) {
          sibling = ins[Math.max(0, previousIndex)];
        } else if (e.keyCode !== 8 && e.keyCode != 37 && nextIndex < maxInput) {
          sibling = ins[Math.min(maxInput - 1, nextIndex)];
        } else {
          focus(this);
        }
        if (sibling) {
          focus(sibling);
        } else if (this == ins[maxInput - 1] && this.value?.length) {
          const code = ins.map((input) => input.value).join("");
          if (code.length == maxInput) {
            const event = new CustomEvent("CheckoutPhoneNumberCompleted", {
              detail: { otp_code: code },
            });
            document.dispatchEvent(event);
          }
        }
      });

      input.addEventListener("focus", function (e) {
        this.value = this.value;
        if (this === in1) return;
        if (in1.value == "") {
          focus(in1);
        }
        const index = ins.findIndex((i) => i == input);
        const previousIndex = index - 1;
        const sibling = ins[Math.max(0, previousIndex)];
        // NOTE: Forbid focusing in empty inputs
        if (sibling.value == "") {
          focus(sibling);
        }
      });

      input.addEventListener("input", function (e) {
        if (this.value.length >= 1) {
          this.value = e.data;
        }
      });

      input.addEventListener("paste", function (e) {
        let data = (e.clipboardData || window.clipboardData).getData("text");
        if (!data) return;
        if (!isNaN(parseInt(data))) {
          const max = Math.min(data.length + index, maxInput);
          let lastInput;
          let inputIndex = index;
          let dataIndex = 0;
          for (; inputIndex < max; inputIndex++) {
            lastInput = ins[inputIndex];
            ins[inputIndex].value = data[dataIndex];
            dataIndex++;
          }
          if (lastInput) {
            focus(lastInput);
          }
        }
        e.stopPropagation();
        e.preventDefault();
      });
    });
  }

  resetMessages() {
    (this.element.querySelectorAll("[data-input-status-type]") ?? []).forEach(
      (el) => {
        el.innerHTML = "";
      }
    );
  }

  setValid(message) {
    this.checkoutLoginValid.innerHTML = message;
  }

  setError(message) {
    this.checkoutLoginError.innerHTML = message;
  }


    remove() {
      this.element.innerHTML = '';
    }
    render(initializeChildrenInstances = false) {
      const is_server = true;
      const show_checkout_login = this.show_checkout_login ?? false ;
const contact = this.contact ?? {"first_name":"Todd","masked_phone":"1234"} ;

      
      let html = '';
      {
        html += `<div data-page-element="SubHeadline/V1" class="elSubheadlineWrapper id-SubHeadline/V1"><h2 class="elSubheadline"><span> Welcome Back ${contact.first_name}</span></h2></div><div data-page-element="Paragraph/V1" class="elParagraphWrapper id-Paragraph/V1"><p class="elParagraph"><span> Enable 1 click checkout by entering the number have sent to your phone ending with ${contact.masked_phone}</span></p></div><div data-page-element="Paragraph/V1" class="elParagraphWrapper id-Paragraph/V1"><p class="elParagraph"><span><a class="elLink elLinkResendCode">Resend Code</a></span></p></div><div class="elCheckoutLoginInputContent"><div data-page-element="Input/V1" class="elFormItemWrapper elInputWrapper de-input-block id-Input/V1 labelInside" type="otc-1" data-liquid-replace="item"><input class="elFormItem elInput inputHolder " value="" type="number" name="otc-1" pattern="[0-9]" autocomplete="one-time-code" inputtype="numeric" data-prevent-submit="true" data-prevent-garlic="true" placeholder="" maxlength=""/><div class="elLabel"><div class="borderHolder"></div><div class="borderHolder labelText"><label></label></div><div class="borderHolder"></div></div><div class="inputHolder" data-input-status-type="true" data-error-container="true"></div><div class="input-icon"><i class="fas fa-exclamation"></i></div></div><div data-page-element="Input/V1" class="elFormItemWrapper elInputWrapper de-input-block id-Input/V1 labelInside" type="otc-2" data-liquid-replace="item"><input class="elFormItem elInput inputHolder " value="" type="number" name="otc-2" pattern="[0-9]" autocomplete="" inputtype="numeric" data-prevent-submit="true" data-prevent-garlic="true" placeholder="" maxlength=""/><div class="elLabel"><div class="borderHolder"></div><div class="borderHolder labelText"><label></label></div><div class="borderHolder"></div></div><div class="inputHolder" data-input-status-type="true" data-error-container="true"></div><div class="input-icon"><i class="fas fa-exclamation"></i></div></div><div data-page-element="Input/V1" class="elFormItemWrapper elInputWrapper de-input-block id-Input/V1 labelInside" type="otc-3" data-liquid-replace="item"><input class="elFormItem elInput inputHolder " value="" type="number" name="otc-3" pattern="[0-9]" autocomplete="" inputtype="numeric" data-prevent-submit="true" data-prevent-garlic="true" placeholder="" maxlength=""/><div class="elLabel"><div class="borderHolder"></div><div class="borderHolder labelText"><label></label></div><div class="borderHolder"></div></div><div class="inputHolder" data-input-status-type="true" data-error-container="true"></div><div class="input-icon"><i class="fas fa-exclamation"></i></div></div><div data-page-element="Input/V1" class="elFormItemWrapper elInputWrapper de-input-block id-Input/V1 labelInside" type="otc-4" data-liquid-replace="item"><input class="elFormItem elInput inputHolder " value="" type="number" name="otc-4" pattern="[0-9]" autocomplete="" inputtype="numeric" data-prevent-submit="true" data-prevent-garlic="true" placeholder="" maxlength=""/><div class="elLabel"><div class="borderHolder"></div><div class="borderHolder labelText"><label></label></div><div class="borderHolder"></div></div><div class="inputHolder" data-input-status-type="true" data-error-container="true"></div><div class="input-icon"><i class="fas fa-exclamation"></i></div></div><div data-page-element="Input/V1" class="elFormItemWrapper elInputWrapper de-input-block id-Input/V1 labelInside" type="otc-5" data-liquid-replace="item"><input class="elFormItem elInput inputHolder " value="" type="number" name="otc-5" pattern="[0-9]" autocomplete="" inputtype="numeric" data-prevent-submit="true" data-prevent-garlic="true" placeholder="" maxlength=""/><div class="elLabel"><div class="borderHolder"></div><div class="borderHolder labelText"><label></label></div><div class="borderHolder"></div></div><div class="inputHolder" data-input-status-type="true" data-error-container="true"></div><div class="input-icon"><i class="fas fa-exclamation"></i></div></div></div><div class="inputStatusContainer"><span data-input-status-type="valid"></span><span data-input-status-type="error"></span></div><div data-page-element="Paragraph/V1" class="elParagraphWrapper id-Paragraph/V1"><p class="elParagraph"><span><a class="elLink elLinkContinueAsGuest">Continue as guest</a></span></p></div>`

      }

      this.element.innerHTML = html;

      if (initializeChildrenInstances) {
        CF2Component.hydrateTree(this.element);
      }
    }


}

window["CheckoutLoginV1"] = CheckoutLoginV1

